export default __webpack_public_path__ + "static/media/header-scaled.17f250b7.jpg";